import BookingPreview from './components/BookingPreview.css';

export default {
	BookingPreview
};
